<template>
  <b-modal
    :id="modalId"
    centered
    hide-header
    hide-footer
    :dialog-class="dialogClass"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
  >
    <div class="error-wrapper text-center">
      <div class="error-icon">×</div>
      <h4 class="error-title">{{ title }}</h4>
      <p class="error-message mb-0">{{ message }}</p>
    </div>
    <div class="error-footer">
      <b-button variant="danger" class="error-btn" @click="$bvModal.hide(modalId)">
        {{ buttonLabel }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "modal-error-action",
  props: {
    modalId: {
      type: String,
      default: "modal-error-action",
    },
    title: {
      type: String,
      default: "Error",
    },
    message: {
      type: String,
      default: "Terjadi kesalahan.",
    },
    buttonLabel: {
      type: String,
      default: "OK",
    },
    dialogClass: {
      type: String,
      default: "modal-error-action-dialog",
    },
  },
};
</script>

<style scoped>
.error-wrapper {
  padding: 8px 0 4px;
}

.error-icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: #ffe4e6;
  color: #ff2d2d;
  font-size: 36px;
  line-height: 52px;
  font-weight: 300;
}

.error-title {
  margin-bottom: 10px;
  font-weight: 600;
}

.error-message {
  color: #6b7280;
}

.error-footer {
  margin-top: 20px;
}

.error-btn {
  width: 100%;
  font-weight: 600;
  background-color: #ff2d2d;
  border-color: #ff2d2d;
}

.error-btn:hover,
.error-btn:focus,
.error-btn:active {
  background-color: #ff1f1f !important;
  border-color: #ff1f1f !important;
}

:deep(.modal-error-action-dialog .modal-content) {
  border-radius: 8px;
  border: 0;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
}

:deep(.modal-error-action-dialog .modal-body) {
  padding: 18px 18px 14px;
  display: flex;
  flex-direction: column;
}
</style>
